'use client';

import { type CSSProperties } from 'react';
import { cn } from '../../lib/cn';

export interface SToggleProps {
  /** 선택(on/off) 상태 */
  value?: boolean;
  /** 라벨 */
  label?: string;
  /** 비활성 */
  disabled?: boolean;
  /** 변경 (sdUpdate) */
  onValueChange?: (value: boolean) => void;
  className?: string;
  style?: CSSProperties;
}

/**
 * SToggle — sd-toggle 포팅. 알약형 토글 버튼.
 * default(흰 배경/회색), hover(파란 채움), select(흰 배경/파란 테두리·글자), disabled.
 */
export function SToggle({
  value = false,
  label = '',
  disabled = false,
  onValueChange,
  className,
  style,
}: SToggleProps) {
  const border = disabled
    ? 'var(--cmp-toggle-border-disabled)'
    : value
      ? 'var(--cmp-toggle-border-select)'
      : 'var(--cmp-toggle-border-default)';
  const bg = disabled
    ? 'var(--cmp-toggle-bg-disabled)'
    : value
      ? 'var(--cmp-toggle-bg-select)'
      : 'var(--cmp-toggle-bg-default)';
  const content = disabled
    ? 'var(--cmp-toggle-content-disabled)'
    : value
      ? 'var(--cmp-toggle-content-select)'
      : 'var(--cmp-toggle-content-default)';

  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={value}
      onClick={() => !disabled && onValueChange?.(!value)}
      className={cn(
        'box-border inline-flex h-[28px] items-center justify-center whitespace-nowrap rounded-full border border-solid px-[12px] text-[14px] font-medium leading-[24px] transition-colors',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        // 미선택(off) hover 시 파란 채움 + 흰 글자
        !disabled &&
          !value &&
          'hover:!bg-[var(--cmp-toggle-bg-hover)] hover:!text-[color:var(--cmp-toggle-content-hover)] hover:!border-[color:var(--cmp-toggle-bg-hover)]',
        className,
      )}
      style={{ background: bg, borderColor: border, color: content, ...style } as CSSProperties}
    >
      {label}
    </button>
  );
}
